/** Step metadata for script-audio-align pipeline popup. */

export const SCRIPT_AUDIO_ALIGN_STEP_LABELS = {
  split_script: 'Split script',
  detect_alignment: 'Alignment engine',
  tts_sentence: 'Text-to-speech',
  align_words: 'Align words',
  gap: 'Silence gap',
  concat_audio: 'Concatenate audio',
  build_timeline: 'Build timeline',
  plan_visuals: 'Suggest visual cues',
  render_visuals: 'Render visuals',
  build_screenplay: 'Build screenplay',
};

export function scriptAudioAlignStepLabel(step) {
  const id = String(step?.step_id || '');
  if (SCRIPT_AUDIO_ALIGN_STEP_LABELS[id]) return SCRIPT_AUDIO_ALIGN_STEP_LABELS[id];
  if (id.startsWith('tts_sentence_')) return `TTS sentence ${Number(id.split('_').pop()) + 1}`;
  if (id.startsWith('align_words_')) return `Align words — sentence ${Number(id.split('_').pop()) + 1}`;
  if (id.startsWith('gap_')) return `Gap after sentence ${Number(id.split('_').pop()) + 1}`;
  return step?.title || id || 'Step';
}

export function formatPipelineJson(value) {
  if (value == null) return 'null';
  try {
    return JSON.stringify(value, null, 2);
  } catch {
    return String(value);
  }
}
